<template>
  <div class="home">
    <van-cell class="actValue" title="来访预约">
      <span @click="toInvite">邀约访客</span>
    </van-cell>
    <p class="part_title">查询您要找的人</p>
    <div class="_search">
      <div class="search_wrap">
        <van-field v-model.trim="phone" class="hasinput" placeholder="输入被访人电话号码" />
        <van-button type="info" @click="handleSearch">查询</van-button>
      </div>
      <div class="search_result">
        <p v-if="emptyMsg" class="empty">
          <van-icon name="warning" />
          {{ emptyMsg }}
        </p>
        <div v-if="staffInfo" class="_result">
          <p v-if="staffInfo.name">
            <span>{{ staffInfo.name }}</span>
          </p>
          <p v-if="staffInfo.company">
            <span>公司：</span>
            {{ staffInfo.company }}
          </p>
          <p v-if="staffInfo.edifice">
            <span>大厦：</span>
            {{ staffInfo.edifice }}
          </p>
          <p v-if="staffInfo. floor">
            <span>楼层：</span>
            {{ staffInfo. floor }}
          </p>
        </div>
      </div>
    </div>
    <p class="part_title">选择来访事由及时间</p>
    <van-cell required class="actValue" title="来访事由">
      <span @click="showCause = true">{{ dataFrom.reason }}</span>
    </van-cell>
    <van-cell required class="actValue" title="来访时间">
      <span @click="showPicker =true">{{ dataFrom.visitDate }}</span>
    </van-cell>
    <van-field v-model.trim="dataFrom.carNumber" class="hasinput" label="来访车牌" placeholder="请输入来访车牌号" />
    <van-button
      :disabled="!dataFrom.beVisitStaffId && clickFlag"
      class="sub_btn"
      type="info"
      @click="handleAppointment"
    >提交预约申请</van-button>

    <div v-show="showCause" class="piker_wrap" @click="showCause = false">
      <ul class="piker_content" @click.stop>
        <li
          v-for="(item,index) in reasonList"
          :key="index"
          :class="{active:active==index}"
          @click="changeReason(item,index)"
        >{{ item }}</li>
      </ul>

      <div class="cancel" @click="onCancel">取消</div>
    </div>
    <van-dialog v-model="showDialog" class="new—dialog" title="温馨提示" show-cancel-button confirm-button-text="预约" :before-close="beforeClose" message-align="left">
      <div class="van-dialog__message">
        <p>您已登记于{{ visitorMsg.visitDate }}访问 {{ visitorMsg.beVisitCompanyName }} {{ visitorMsg.beVisitStaffName }}，当前状态:{{ visitorMsg.visitorStatusName }}</p>
        <p>继续预约将结束上述访问（取消上述访问），是否预约？</p>
        <p class="tips">*系统每人每天仅支持同时生效1条访问记录</p>
      </div>

    </van-dialog>
    <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :filter="filter"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="timeConfirm"
        @cancel="showPicker =false"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { Appointment, getReasons, searchAppointment, cancelAppointment } from '@/api/home'
import { GetUserInfo } from '@/api/user'
export default {
  name: 'Home',
  data() {
    return {
      reasonList: [],
      userInfo: {}, // 用户信息，用于邀约访客判断是否已认证为员工
      phone: '',
      showDialog: false,
      clickFlag: true, // 预约申请按钮只点击一次
      dataFrom: {
        reason: '',
        visitDate: '',
        carNumber: '',
        beVisitStaffId: ''
      },
      visitorMsg: {},
      showCause: false,
      staffInfo: {},
      active: 0,
      emptyMsg: '',
      minHour: 10,
      maxHour: 20,
      empty: false,
      showPicker: false,
      minDate: new Date(),
      maxDate: new Date(2023, 10, 1),
      currentDate: ''
    }
  },
  created() {
    this.setTime()
    this.getReasonList()
    this.getUserInfo()
  },
  methods: {
    filter(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 30 === 0)
      } else {
        return options
      }
    },
    formatter(type, value) {
      switch (type) {
        case 'year':
          value = `${value}年`
          break
        case 'month':
          value = `${value}月`
          break
        case 'day':
          value = `${value}日`
          break
        case 'hour':
          value = `${value}时`
          break
        case 'minute':
          value = `${value}分`
          break
      }
      return value
    },
    handleSearch() {
      if (!this.phone) {
        this.$toast({
          message: '请输入被访人电话号码'
        })
        return
      }
      const data = {
        phone: this.phone
      }
      searchAppointment(data).then(res => {
        if (res.code !== 200) {
          this.emptyMsg = res.message
          this.staffInfo = {}
        } else {
          this.emptyMsg = ''
          this.staffInfo = res.data
          this.dataFrom.beVisitStaffId = res.data.id
        }
      })
    },
    beforeClose(action, done) {
      // done(false) // 不关闭弹框
      if (action === 'confirm') {
        const data = {
          id: this.visitorMsg.id,
          status: 'CANCEL'
        }
        cancelAppointment(data).then(res => {
          this.clickFlag = true
          this.handleAppointment()
          // done()
        })
      } else if (action === 'cancel') {
        done() // 关闭
        this.clickFlag = true
      }
    },
    // 设置默认时间为当前时间的下一个整点
    setTime() {
      const now = moment().format('HH:mm:ss')

      var num = now.indexOf(':')

      var time = Number(now.substring(0, num)) + 1
      if (time.toString().length === 1) {
        time = '0' + time
      }
      this.dataFrom.visitDate = moment().format('YYYY-MM-DD ') + time + ':00'
      this.currentDate = new Date(moment().format('YYYY/MM/DD ') + time + ':00') // ios不支持YYYY_MM_DD 的new Date写法
      this.minDate = new Date(moment().format('YYYY/MM/DD HH') + ':00')
    },
    timeConfirm(val) {
      var d = new Date().getTime()
      var d1 = new Date(val).getTime()
      if (d1 < d) {
        this.$toast({
          message: '预约时间不能在当前时间之前'
        })
        return
      }

      this.dataFrom.visitDate = moment(val).format('YYYY-MM-DD HH:mm')
      this.showPicker = false
    },
    changeReason(item, i) {
      this.active = i
      this.dataFrom.reason = item
      this.showCause = false
    },
    getReasonList() {
      const data = {}
      getReasons(data).then(res => {
        this.reasonList = res.data.reasons
        this.dataFrom.reason = this.reasonList[0]
        this.appointmentInfo()
      })
    },
    onCancel() {
      this.showCause = false
    },
    handleAppointment() {
      if (!this.clickFlag) return
      this.clickFlag = false
      Appointment(this.dataFrom).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: '/appointmentSuc' })
        } else if (res.code === 50001) {
          this.visitorMsg = res.data
          this.showDialog = true
          this.clickFlag = true
        } else {
          this.$dialog.alert({
            title: '温馨提示',
            message: res.message,
            confirmButtonText: '我知道了'
          })
          this.clickFlag = true
        }
      }).catch(() => {
        this.clickFlag = true
      })
    },
    toInvite() {
      if (this.userInfo.staff) {
        this.$router.push({ path: '/invite' })
        return
      }
      this.$router.push({ path: '/unverified' })
    },
    getUserInfo() {
      const data = {}
      GetUserInfo(data).then(res => {
        res.data ? this.userInfo = res.data : this.$router.push({ name: 'bind' })
      })
    },
    appointmentInfo() {
      if (this.$route.params.id && sessionStorage.getItem('appointmentInfo')) {
        const appointmentInfos = JSON.parse(sessionStorage.getItem('appointmentInfo'))
        this.dataFrom.reason = appointmentInfos.reason
        this.active = this.reasonList.indexOf(this.dataFrom.reason)
        const d = new Date().getTime()
        const d1 = new Date(moment(appointmentInfos.visitDate).format('YYYY/MM/DD HH:mm')).getTime()
        if (d <= d1) {
          this.dataFrom.visitDate = appointmentInfos.visitDate
          this.$set(this, 'currentDate', new Date(moment(appointmentInfos.visitDate).format('YYYY/MM/DD HH:mm')))
        }
        this.phone = appointmentInfos.beVisitStaffPhone
        if (this.phone) {
          this.handleSearch()
        }
      }
    }
  }

}
</script>

<style lang="less">
@import './style/home.less';
</style>
